import './panel.css';
export default {
  "modifiers": {
    "bordered": "pf-m-bordered",
    "secondary": "pf-m-secondary",
    "raised": "pf-m-raised",
    "scrollable": "pf-m-scrollable"
  },
  "panel": "pf-v6-c-panel",
  "panelFooter": "pf-v6-c-panel__footer",
  "panelHeader": "pf-v6-c-panel__header",
  "panelMain": "pf-v6-c-panel__main",
  "panelMainBody": "pf-v6-c-panel__main-body"
};